export const PLANET_TRAITS = {
    "HAZARDOUS": 0,
    "INDUSTRIAL": 1,
    "CULTURAL": 2,
};

export const TECH_SPECIALTIES = {
    "BIOTIC": 0,
    "WARFARE": 1,
    "PROPULSION": 2,
    "CYBERNETIC": 3,
};

export const ANOMALIES = {
    "NEBULA": 0,
    "GRAVITY_RIFT": 1,
    "ASTEROID_FIELD": 2,
    "SUPERNOVA": 3,
    "ENTROPIC_SCAR": 4,
};

export const WORMHOLES = {
    "ALPHA": 0,
    "BETA": 1,
    "DELTA": 2,
};

export let planet_data = [
    {
        "name": "Mecatol Rex",
        "traits": null,
        "tech_specialties": null,
        "resources": 1,
        "influence": 6,
    },
    {
        "name": "Abyz",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 3,
        "influence": 0,
    },
    {
        "name": "Fria",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 2,
        "influence": 0,
    },
    {
        "name": "Arinam",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "Meer",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": [TECH_SPECIALTIES.WARFARE],
        "resources": 0,
        "influence": 4,
    },
    {
        "name": "Arnor",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "Lor",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "Bereg",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 3,
        "influence": 1,
    },
    {
        "name": "Lirta IV",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 2,
        "influence": 3,
    },
    {
        "name": "Centauri",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 3,
    },
    {
        "name": "Gral",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.PROPULSION],
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Corneeq",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "Resculon",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 0,
    },
    {
        "name": "Dal Bootha",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 0,
        "influence": 2,
    },
    {
        "name": "Xxehan",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Lazar",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.CYBERNETIC],
        "resources": 1,
        "influence": 0,
    },
    {
        "name": "Sakulag",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "Lodor",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 3,
        "influence": 1,
    },
    {
        "name": "Mehar Xull",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": [TECH_SPECIALTIES.WARFARE],
        "resources": 1,
        "influence": 3,
    },
    {
        "name": "Mellon",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 0,
        "influence": 2,
    },
    {
        "name": "Zohbat",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 3,
        "influence": 1,
    },
    {
        "name": "New Albion",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.BIOTIC],
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Starpoint",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 3,
        "influence": 1,
    },
    {
        "name": "Quann",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "Qucen'n",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "Rarron",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 0,
        "influence": 3,
    },
    {
        "name": "Saudor",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 2,
    },
    {
        "name": "Tar'Mann",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.BIOTIC],
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Tequ'ran",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 2,
        "influence": 0,
    },
    {
        "name": "Torkan",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 0,
        "influence": 3,
    },
    {
        "name": "Thibah",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.PROPULSION],
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Vefut II",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 2,
        "influence": 2,
    },
    {
        "name": "Wellon",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.CYBERNETIC],
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "Archon Vail",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": [TECH_SPECIALTIES.PROPULSION],
        "resources": 1,
        "influence": 3,
    },
    {
        "name": "Perimeter",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "Ang",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.WARFARE],
        "resources": 2,
        "influence": 0,
    },
    {
        "name": "Sem-Lore",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": [TECH_SPECIALTIES.CYBERNETIC],
        "resources": 3,
        "influence": 2,
    },
    {
        "name": "Vorhal",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": [TECH_SPECIALTIES.BIOTIC],
        "resources": 0,
        "influence": 2,
    },
    {
        "name": "Atlas",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 3,
        "influence": 1,
    },
    {
        "name": "Primor",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "Hope's End",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 3,
        "influence": 0,
    },
    {
        "name": "Cormund",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 2,
        "influence": 0,
    },
    {
        "name": "Everra",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 3,
        "influence": 1,
    },
    {
        "name": "Accoen",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 3,
    },
    {
        "name": "Joel Ir",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 3,
    },
    {
        "name": "Kraag",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "Siig",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 0,
        "influence": 2,
    },
    {
        "name": "Alio Prima",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Ba'kal",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 3,
        "influence": 2,
    },
    {
        "name": "Lisis",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 2,
    },
    {
        "name": "Velnor",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.WARFARE],
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "Cealdri",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": [TECH_SPECIALTIES.CYBERNETIC],
        "resources": 0,
        "influence": 2,
    },
    {
        "name": "Xanhact",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 0,
        "influence": 1,
    },
    {
        "name": "Vega Major",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "Vega Minor",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": [TECH_SPECIALTIES.PROPULSION],
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "Abaddon",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 0,
    },
    {
        "name": "Ashtroth",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 2,
        "influence": 0,
    },
    {
        "name": "Loki",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "Rigel I",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 0,
        "influence": 1,
    },
    {
        "name": "Rigel II",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "Rigel III",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.BIOTIC],
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Faunus",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.BIOTIC],
        "resources": 1,
        "influence": 3,
    },
    {
        "name": "Garbozia",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "Emelpar",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 0,
        "influence": 2,
    },
    {
        "name": "Tempesta",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": [TECH_SPECIALTIES.PROPULSION],
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Olergodt",
        "traits": [PLANET_TRAITS.CULTURAL, PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": [TECH_SPECIALTIES.CYBERNETIC, TECH_SPECIALTIES.WARFARE],
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "Andeara",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.PROPULSION],
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Vira-Pics III",
        "traits": [PLANET_TRAITS.CULTURAL, PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 2,
        "influence": 3,
    },
    {
        "name": "Lesab",
        "traits": [PLANET_TRAITS.HAZARDOUS, PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "New Terra",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Tinnes",
        "traits": [PLANET_TRAITS.HAZARDOUS, PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.BIOTIC],
        "resources": 2,
        "influence": 1,
    },
    {
        "name": "Cresius",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 0,
        "influence": 1,
    },
    {
        "name": "Lazul Rex",
        "traits": [PLANET_TRAITS.INDUSTRIAL, PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 2,
        "influence": 2,
    },
    {
        "name": "Tiamat",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": [TECH_SPECIALTIES.CYBERNETIC, TECH_SPECIALTIES.CYBERNETIC],
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "Hercalor",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 0,
    },
    {
        "name": "Kostboth",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 0,
        "influence": 1,
    },
    {
        "name": "Capha",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 3,
        "influence": 0,
    },
    {
        "name": "Bellatrix",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "Tsion Station",
        "traits": null,
        "tech_specialties": null,
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Horizon",
        "traits": [PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "El'Nath",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 2,
        "influence": 0,
    },
    {
        "name": "Luthien VI",
        "traits": [PLANET_TRAITS.HAZARDOUS],
        "tech_specialties": null,
        "resources": 3,
        "influence": 1,
    },
    {
        "name": "Tarana",
        "traits": [PLANET_TRAITS.INDUSTRIAL, PLANET_TRAITS.CULTURAL],
        "tech_specialties": null,
        "resources": 1,
        "influence": 2,
    },
    {
        "name": "Oluz Station",
        "traits": null,
        "tech_specialties": null,
        "resources": 1,
        "influence": 1,
    },
    {
        "name": "Industrex",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": [TECH_SPECIALTIES.HAZARDOUS],
        "resources": 2,
        "influence": 0,
    },
    {
        "name": "Lemox",
        "traits": [PLANET_TRAITS.INDUSTRIAL],
        "tech_specialties": null,
        "resources": 0,
        "influence": 3,
    },
    {
        "name": "The Watchtower",
        "traits": null,
        "tech_specialties": null,
        "resources": 1,
        "influence": 1,
    },
];

export let system_data = [
    {
        "id": 18,
        "planets": ["Mecatol Rex"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 39,
        "planets": [],
        "anomalies": null,
        "wormhole": WORMHOLES.ALPHA,
    },
    {
        "id": 43,
        "planets": [],
        "anomalies": [ANOMALIES.SUPERNOVA],
        "wormhole": null,
    },
    {
        "id": 46,
        "planets": [],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 49,
        "planets": [],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 44,
        "planets": [],
        "anomalies": [ANOMALIES.ASTEROID_FIELD],
        "wormhole": null,
    },
    {
        "id": 40,
        "planets": [],
        "anomalies": null,
        "wormhole": WORMHOLES.BETA,
    },
    {
        "id": 48,
        "planets": [],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 45,
        "planets": [],
        "anomalies": [ANOMALIES.ASTEROID_FIELD],
        "wormhole": null,
    },
    {
        "id": 47,
        "planets": [],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 42,
        "planets": [],
        "anomalies": [ANOMALIES.NEBULA],
        "wormhole": null,
    },
    {
        "id": 50,
        "planets": [],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 41,
        "planets": [],
        "anomalies": [ANOMALIES.GRAVITY_RIFT],
        "wormhole": null,
    },
    {
        "id": 32,
        "planets": ["Dal Bootha", "Xxehan"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 26,
        "planets": ["Lodor"],
        "anomalies": null,
        "wormhole": WORMHOLES.ALPHA,
    },
    {
        "id": 29,
        "planets": ["Qucen'n", "Rarron"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 38,
        "planets": ["Abyz", "Fria"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 22,
        "planets": ["Tar'Mann"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 21,
        "planets": ["Thibah"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 33,
        "planets": ["Corneeq", "Resculon"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 19,
        "planets": ["Wellon"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 28,
        "planets": ["Tequ'ran", "Torkan"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 24,
        "planets": ["Mehar Xull"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 37,
        "planets": ["Arinam", "Meer"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 30,
        "planets": ["Mellon", "Zohbat"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 20,
        "planets": ["Vefut II"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 27,
        "planets": ["New Albion", "Starpoint"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 23,
        "planets": ["Saudor"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 31,
        "planets": ["Lazar", "Sakulag"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 35,
        "planets": ["Bereg", "Lirta IV"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 34,
        "planets": ["Centauri", "Gral"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 36,
        "planets": ["Arnor", "Lor"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 25,
        "planets": ["Quann"],
        "anomalies": null,
        "wormhole": WORMHOLES.BETA,
    },
    {
        "id": 59,
        "planets": ["Archon Vail"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 60,
        "planets": ["Perimeter"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 61,
        "planets": ["Ang"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 62,
        "planets": ["Sem-Lore"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 63,
        "planets": ["Vorhal"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 64,
        "planets": ["Atlas"],
        "anomalies": null,
        "wormhole": WORMHOLES.BETA,
    },
    {
        "id": 65,
        "planets": ["Primor"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 66,
        "planets": ["Hope's End"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 67,
        "planets": ["Cormund"],
        "anomalies": [ANOMALIES.GRAVITY_RIFT],
        "wormhole": null,
    },
    {
        "id": 68,
        "planets": ["Everra"],
        "anomalies": [ANOMALIES.NEBULA],
        "wormhole": null,
    },
    {
        "id": 69,
        "planets": ["Accoen", "Joel Ir"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 70,
        "planets": ["Kraag", "Siig"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 71,
        "planets": ["Alio Prima", "Ba'kal"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 72,
        "planets": ["Lisis", "Velnor"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 73,
        "planets": ["Cealdri", "Xanhact"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 74,
        "planets": ["Vega Major", "Vega Minor"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 75,
        "planets": ["Abaddon", "Ashtroth", "Loki"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 76,
        "planets": ["Rigel I", "Rigel II", "Rigel III"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 77,
        "planets": [],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 78,
        "planets": [],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 79,
        "planets": [],
        "anomalies": [ANOMALIES.ASTEROID_FIELD],
        "wormhole": WORMHOLES.ALPHA,
    },
    {
        "id": 80,
        "planets": [],
        "anomalies": [ANOMALIES.SUPERNOVA],
        "wormhole": null,
    },
    {
        "id": 97,
        "planets": ["Faunus"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 98,
        "planets": ["Garbozia"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 99,
        "planets": ["Emelpar"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 100,
        "planets": ["Tempesta"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 101,
        "planets": ["Olergodt"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 102,
        "planets": ["Andeara"],
        "anomalies": null,
        "wormhole": WORMHOLES.ALPHA,
    },
    {
        "id": 103,
        "planets": ["Vira-Pics III"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 104,
        "planets": ["Lesab"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 105,
        "planets": ["New Terra", "Tinnes"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 106,
        "planets": ["Cresius", "Lazul Rex"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 107,
        "planets": ["Tiamat", "Hercalor"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 108,
        "planets": ["Kostboth", "Capha"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 109,
        "planets": ["Bellatrix", "Tsion Station"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 110,
        "planets": ["Horizon", "El'Nath", "Luthien VI"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 111,
        "planets": ["Tarana", "Oluz Station"],
        "anomalies": null,
        "wormhole": null,
    },
    {
        "id": 113,
        "planets": [],
        "anomalies": [ANOMALIES.GRAVITY_RIFT],
        "wormhole": WORMHOLES.BETA,
    },
    {
        "id": 114,
        "planets": [],
        "anomalies": [ANOMALIES.ENTROPIC_SCAR],
        "wormhole": null,
    },
    {
        "id": 115,
        "planets": ["Industrex"],
        "anomalies": [ANOMALIES.ASTEROID_FIELD],
        "wormhole": null,
    },
    {
        "id": 116,
        "planets": ["Lemox"],
        "anomalies": [ANOMALIES.ENTROPIC_SCAR],
        "wormhole": null,
    },
    {
        "id": 117,
        "planets": ["The Watchtower"],
        "anomalies": [ANOMALIES.ASTEROID_FIELD, ANOMALIES.GRAVITY_RIFT],
        "wormhole": null,
    },
];
